// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as StoryverseHeader$LiteracyplanetClientSxEntry from "./StoryverseHeader.res.mjs";
import * as StoryverseComponents$LiteracyplanetClientSxEntry from "./StoryverseComponents.res.mjs";
import * as StoryverseLevelPanel$LiteracyplanetClientSxEntry from "./StoryverseLevelPanel.res.mjs";
import * as StoryversePanelContext$LiteracyplanetClientSxEntry from "../StoryversePanelContext.res.mjs";
import * as StoryverseNavigationQuery$LiteracyplanetClientSxEntry from "../StoryverseNavigationQuery.res.mjs";

function StoryverseNavBar(props) {
  var onClickShop = props.onClickShop;
  var lockShop = props.lockShop;
  var onClickArcade = props.onClickArcade;
  var lockArcade = props.lockArcade;
  var onClickCollections = props.onClickCollections;
  var onClickBog = props.onClickBog;
  var match = Curry._1(StoryversePanelContext$LiteracyplanetClientSxEntry.Context.use, undefined);
  var panelOpen = match.panelOpen;
  var navigation = StoryverseNavigationQuery$LiteracyplanetClientSxEntry.use(!panelOpen);
  return React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.ScrollPanel.make, {
              children: null
            }, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.Spacer.make, {}), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.HeaderPanel.make, {
                  children: null
                }, React.createElement(StoryverseHeader$LiteracyplanetClientSxEntry.make, {
                      onClickMissions: props.onClickMissions,
                      onClickAcademy: props.onClickAcademy,
                      onClickWordFlyers: props.onClickWordFlyers,
                      onClickIntrepizine: props.onClickIntrepizine,
                      onClickMyWords: props.onClickMyWords,
                      onClickLibrary: props.onClickLibrary,
                      onClickBog: onClickBog,
                      onClickCollections: onClickCollections,
                      lockArcade: lockArcade,
                      onClickArcade: onClickArcade,
                      lockShop: lockShop,
                      onClickShop: onClickShop,
                      showLibraryLink: props.showLibraryLink,
                      onClickReports: props.onClickReports,
                      onClickLogout: props.onClickLogout,
                      onClickTeacherMode: props.onClickTeacherMode,
                      showTeacherModeWidget: props.showTeacherModeWidget,
                      menu: props.menu
                    }), panelOpen ? React.createElement(StoryverseLevelPanel$LiteracyplanetClientSxEntry.make, {
                        userName: props.userName,
                        navigation: navigation,
                        onClickBog: onClickBog,
                        onClickCollections: onClickCollections,
                        lockArcade: lockArcade,
                        onClickArcade: onClickArcade,
                        lockShop: lockShop,
                        onClickShop: onClickShop,
                        closeHeaderPanel: match.closePanel
                      }) : React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.Spacer.make, {})));
}

var make = StoryverseNavBar;

export {
  make ,
}
/* react Not a pure module */
